import {Injectable} from '@angular/core';
import {Headers, Http, Response} from '@angular/http';
import 'rxjs/add/operator/toPromise';
import {webapi} from '../../../../../shared/my-constants';

@Injectable()
export class CpoeDoctorAdviceService {
  private headers = new Headers({'Content-Type': 'application/json'});
  private GetAllFrequentlyUsedServices = webapi + 'trn_staff_favourite_service/get_all_record/';
  private AddRecord = webapi + 'trn_staff_favourite_service/create';
  private DeleteRecord = webapi + 'trn_staff_favourite_service/delete/';
  private GetRecordOtRequestByTimelineId = webapi + 'temr_ot_request/listByTimelineId?';
  private GetRecordOtRequestByTimelineId_new = webapi + 'temr_ot_request/listByTimelineId_new?';
  private SaveOtRequest= webapi + 'temr_ot_request/create';
  private DeleteRecordOtRequest= webapi + 'temr_ot_request/delete/';
  private GetRecordOtRequestByPatienteId = webapi + 'temr_ot_request/listByPatienteId/';
  private SaveClinicalFinding= webapi + 'temr_clinical_finding/create';
  private GetClinicalFindingByTimelineId= webapi + 'temr_clinical_finding/listByTimelineId/';
  private GetClinicalFindingByTimelineId_new= webapi + 'temr_clinical_finding/listByTimelineId_new/';
  private DeleteRecordClinicalFinding = webapi + 'temr_clinical_finding/delete/';


    constructor(
    private http: Http
  ) {
  }

  getAllFrequentlyUsedServices(staffId: any, unitId: any): Promise<any> {
    // console.log(this.GetAllFrequentlyUsedServices + staffId + '/' + unitId);
    return this.http.get(this.GetAllFrequentlyUsedServices + staffId + '/' + unitId)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  addRecordService(model: any) {
    return this.http.post(this.AddRecord, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

    saveOtRequest(model: any) {
        return this.http.post(this.SaveOtRequest, JSON.stringify(model), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }


    saveClinicalFinding(model: any) {
        return this.http.post(this.SaveClinicalFinding, JSON.stringify(model), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }


    deleteRecordService(id: any) {
    return this.http.put(this.DeleteRecord + id, {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }
  deleteRecordServiceClinicalFinding(id: any) {
    return this.http.put(this.DeleteRecordClinicalFinding + id, {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }


    getRecordOtRequestByTimelineId(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
        return this.http.get(this.GetRecordOtRequestByTimelineId + 'page=' + currentPage + '&size=' + size + '&qString=' + qString +'&sort=' + sort + '&col=' + col)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getRecordOtRequestByTimelineId_new(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
        return this.http.get(this.GetRecordOtRequestByTimelineId_new + 'page=' + currentPage + '&size=' + size + '&qString=' + qString +'&sort=' + sort + '&col=' + col)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }


    deleteRecordOtRequest(otrId: any) {
        return this.http.put(this.DeleteRecordOtRequest + otrId, {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }


    getRecordOtRequestByPatienteId(id: any) {
        return this.http.get(this.GetRecordOtRequestByPatienteId + id)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }
   getRecordClinicalFindingByTimelineId(id: any) {
       return this.http.get(this.GetClinicalFindingByTimelineId + id)
           .toPromise()
           .then(response => response.json())
           .catch(this.handleError);
   }
       getRecordClinicalFindingByTimelineId_new(id: any) {
           return this.http.get(this.GetClinicalFindingByTimelineId_new  + id)
               .toPromise()
               .then(response => response.json())
               .catch(this.handleError);
       }

    private handleError(error: Response | any) {
    return Promise.reject(error.message || error);
  }
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/patient-chart/patient-chart-parent/patient-emr/emr-cpoe/cpoe-doctoradvice/cpoe-doctoradvice.service.ts